import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(getLocalItems),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(watchGetLocalItems);

import { take, put, call, fork } from 'redux-saga/effects';
import makeLocalStorageRequest from '../../../utils/makeLocalStorageRequest';
import { GET_LOCAL_ITEMS, getLocalItemsRequest, getLocalItemsFailure, getLocalItemsSuccess } from '../../../redux/localList/getItems'; // -------------------------------------------------
// WORKER SAGAS
// -------------------------------------------------

export function getLocalItems(request) {
  var payload;
  return _regeneratorRuntime.wrap(function getLocalItems$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(getLocalItemsRequest());

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return call(makeLocalStorageRequest, {
            methodType: request.methodType
          });

        case 5:
          payload = _context.sent;
          _context.next = 8;
          return put(getLocalItemsSuccess(payload));

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          _context.next = 14;
          return put(getLocalItemsFailure(_context.t0.toString()));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2, 10]]);
} // -------------------------------------------------
// WATCHER SAGAS
// -------------------------------------------------

export default function watchGetLocalItems() {
  var _yield$take, request;

  return _regeneratorRuntime.wrap(function watchGetLocalItems$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 9;
            break;
          }

          _context2.next = 3;
          return take(GET_LOCAL_ITEMS);

        case 3:
          _yield$take = _context2.sent;
          request = _yield$take.request;
          _context2.next = 7;
          return fork(getLocalItems, request);

        case 7:
          _context2.next = 0;
          break;

        case 9:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}